var link_preview_default = {
  "fontElementMap": "y9NhT",
  "linkPreview": "_0YyRE",
  "linkPreviewImage": "QIwX4",
  "linkPreviewInfo": "sT4l2",
  "linkPreviewTitle": "nzuZG",
  "ellipsis": "b8Ang",
  "linkPreviewDescription": "B0-0k",
  "linkPreviewUrl": "TwUQM"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
